import { RSError, RSErrorOptions } from "./RSError";

/**
 * Erreurs liées à l'initialisation de l'app (SetupModel) :
 * échec de fetch config/produits/stores au démarrage.
 */
export class RSSetupError<C = Record<string, unknown>> extends RSError<C> {
  constructor(message: string, context?: C, options?: RSErrorOptions) {
    super(message, context, options);
    this.name = "RSSetupError";
    Object.setPrototypeOf(this, RSSetupError.prototype);
  }
}
